<h1>Warehouse Manager</h1>
<mat-card>
  <mat-card-header>
    <mat-card-title>
      <h2>Warehouse Manager List</h2><button *ngIf="user.role == 'admin'" style='background: #000;' mat-raised-button (click)="openDialog()" class="addcomp" color="warn"><mat-icon class="sidenav-icon">add_box</mat-icon> Add Warehouse Manager</button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
    </mat-form-field>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- ID Column -->
            <ng-container matColumnDef="Title">
                <th style='width: 6%;' mat-header-cell *matHeaderCellDef mat-sort-header> Title </th>
                <td mat-cell *matCellDef="let row"> {{row.Title}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="FirstName">
                <th style='width: 12%;' mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                <td mat-cell *matCellDef="let row"> {{row.FirstName}} </td>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="LastName">
                <th style='width: 12%;' mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
                <td mat-cell *matCellDef="let row"> {{row.LastName}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="Companies">
                <th style='width: 14%;' mat-header-cell *matHeaderCellDef mat-sort-header> Companies </th>
                <td mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.Companies}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="PhoneNumber">
                <th style='width: 12%;' mat-header-cell *matHeaderCellDef mat-sort-header> Phone Number</th>
                <td mat-cell *matCellDef="let row"> {{row.PhoneNumber}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="created">
                <th style='width: 10%;' mat-header-cell *matHeaderCellDef mat-sort-header> Created At</th>
                <td mat-cell *matCellDef="let row"> {{row.created}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="status">
                <th style='width: 8%;' mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
                <td mat-cell *matCellDef="let row"> {{row.status}} </td>
            </ng-container>

            <!-- Color Column -->
            <ng-container matColumnDef="actions">
                <th style='width: 20%;' mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <td mat-cell id='actions' *matCellDef="let row">
                    <button *ngIf="user.role == 'admin'" mat-raised-button style='background: #000;' class="btn-xs" (click)="openDialogWithId(row._id)" color="warn"><mat-icon class="sidenav-icon">create</mat-icon>Edit</button>
                  <!--<div *ngIf="user.role == 'admin'">-->
                    <button *ngIf="user.role == 'admin'" mat-raised-button class="btn-xs" (click)='delete(row._id)' color="warn"><mat-icon class="sidenav-icon">delete_sweep</mat-icon>Delete</button>
                  <!--</div>-->
                    <!--<div >-->
                        <button *ngIf="row.status=='active' && user.role == 'admin'; else templateName" mat-raised-button class="btn-xs" (click)='changeWarehouse(row._id,row.status)' color="warn"><mat-icon class="sidenav-icon">cancel</mat-icon>Deactivate</button>
                    <!--</div>-->

                    <ng-template #templateName>
                        <button *ngIf="user.role == 'admin'" mat-raised-button class="btn-xs" style='background: #000;' (click)='changeWarehouse(row._id,row.status)' color="warn"><mat-icon class="sidenav-icon">cancel</mat-icon>activate</button>
                    </ng-template>
                 </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 50, 25, 100]" showFirstLastButtons></mat-paginator>
    </div>

  </mat-card-content>
</mat-card>
